module.exports = __webpack_public_path__ + "img/AKL.772fb695.png";